import { CHECK_WSPOSITIONS, CHECK_WSPOSITIONS_SUCCESS, CHECK_WSPOSITIONS_ERROR} from './actionTypes';

export const checkWsPositions = (user) => {
    return {
        type: CHECK_WSPOSITIONS,
        payload: { user }
    }
}

export const checkWsPositionsSuccess = (ws_positions, message) => {
    return {
        type: CHECK_WSPOSITIONS_SUCCESS,
        payload: {ws_positions, message}
    }
}

export const checkWsPositionsError = (message) => {
    return {
        type: CHECK_WSPOSITIONS_ERROR,
        payload: message
    }
}
